import { lazy } from "react";

const SubscriptionRoutes = [
  {
    path: "/subscription/stats",
    component: lazy(() => import("../../views/subscription/Stats")),
  },
  {
    path: "/subscription/users",
    component: lazy(() => import("../../views/subscription/Users")),
  },
  {
    path: "/subscription/promo",
    component: lazy(() => import("../../views/subscription/Promo")),
  },
];

export default SubscriptionRoutes;
